import cn from 'classnames';
import { FC, useMemo, useState } from 'react';
import { isDesktop } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Arrows } from 'src/components/base-components/Slider/components/Arrows';
import { Button } from 'src/components/common/Button';
import { useBannerActions } from 'src/hooks/useBannerActions';
import { CmsCta } from 'src/types/cms/cmsFieldTypes';
import type { Swiper as SwiperType } from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IRaffleDrawSlider } from '../../types';

export const RaffleDrawSlider: FC<IRaffleDrawSlider> = ({
  images,
  haveButtonAction,
  haveButtonActionData,
  haveSlideClickActionData,
  haveSlideClickAction,
}) => {
  const [mySwiper, setMySwiper] = useState<SwiperType | null>(null);
  const { t } = useTranslation();

  const { loginAction, registrAction, promotionAction, categoryAction } = useBannerActions();

  const ctaAction = (cta: CmsCta | undefined): void => {
    switch (cta?.variant) {
      case 'goToRegister':
        registrAction();
        break;
      case 'goToLogin':
        loginAction();
        break;
      case 'goToPromotion':
        promotionAction(cta?.param);
        break;
      case 'goToCategory':
        categoryAction(cta?.param);
        break;
      default:
        return;
    }
  };

  const clickActionProps = useMemo(
    () =>
      haveSlideClickAction
        ? {
            onClick: () => ctaAction(haveSlideClickActionData),
            style: {
              cursor: 'pointer',
            },
          }
        : {},
    [haveSlideClickAction, haveSlideClickActionData]
  );

  return (
    <div className="banner_container">
      <Swiper
        {...clickActionProps}
        className="carousel_container"
        slidesPerView={1}
        spaceBetween={24}
        autoplay={{
          delay: 5000,
        }}
        speed={1500}
        slidesPerGroup={1}
        loop
        navigation={{ nextEl: '.arrow-right', prevEl: '.arrow-left' }}
        modules={[Pagination, Navigation, Autoplay]}
        onInit={(ev: SwiperType) => setMySwiper(ev)}
      >
        {images?.map((src, i: number) => {
          return (
            <SwiperSlide key={src + i}>
              <div className="raffle_draw_carousel_bannerItem">
                <img className="raffle_draw_slider_item" src={src} alt="" />
                <div className={cn('banner_buttons_container', 'bottomLeft')}>
                  {haveButtonAction && (
                    <Button
                      className="banner_inner_button primary-filled-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        ctaAction(haveButtonActionData);
                      }}
                    >
                      {haveButtonActionData?.label || t('goTo')}
                    </Button>
                  )}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {isDesktop && images?.length > 1 && (
        <Arrows
          type={''}
          rows={1}
          placement="center"
          template={''}
          size={'md'}
          nextClick={() => mySwiper?.slideNext()}
          prevClick={() => mySwiper?.slidePrev()}
        />
      )}
    </div>
  );
};
